export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_01_end.0605993e.jpg";